<template>
  <div>
    <h1>{{album.name}}</h1>
    <div v-if="isEditing">
      <AlbumEditDetail :album="album" :updateAlbum="updateAlbum" />
    </div>
    <div v-else-if="isEditingPages">
      <AlbumEditPages :album="album" :updatePage="updatePage" />
    </div>
    <div v-else-if="isSharing">
      <AlbumShare :album="album" />
    </div>
    <div v-else-if="isPage">
      <PageMaster :id="route.params.pageId" :route="route" :album="album" />
    </div>
    <div v-else>
      <div class="flex owl">
        <div><router-link :to="viewAlbum(album)" class="button">View album</router-link></div>
        <div><router-link :to="shareAlbum(album)" class="button">Share album</router-link></div>
        <div style="margin-left:8em;"><router-link :to="albumEdit(album)" class="button">Edit album details</router-link></div>
        <div><router-link :to="bulkEditPages(album)" class="button">Bulk edit pages</router-link></div>
        <div><button @click="showDropzone = !showDropzone">{{showDropzone ? 'Hide upload area' : 'Add pages'}}</button></div>
        <div><button @click="deleteAlbum(album.id)"><i class="fas fa-trash-alt"></i> Delete album</button></div>
      </div>
      <vue-dropzone v-if="showDropzone" :awss3="awss3" v-on:vdropzone-s3-upload-error="s3UploadError" id="dropzone" :options="dropzoneOptions" :use-custom-slot="true">
        To add pages, click here to upload<br />
        ...or drag and drop files here
      </vue-dropzone>
      <div class="notes">
        Notes:
        <span v-if="album.notes">{{album.notes}}</span>
        <span v-else><em>No notes</em></span>
      </div>
      <div class="credits">
        Credits:
        <span v-if="album.credits">{{album.credits}}</span>
        <span v-else><em>No credits</em></span>
      </div>
      <div class="mt-8">
        <div class="hint">Drag pages to re-order them.</div>
        <OrderPages :pages="album.pages" :order="album.pageOrders" :updatePageOrder="updatePageOrder"
                    :pagesPerSpread="album.pagesPerSpread" :deletePage="deletePage" :album="album"/>
      </div>
    </div>
  </div>
</template>

<script>
import { viewAlbum, shareAlbum, albumEdit, bulkEditPages } from '../utils/routing'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import OrderPages from './OrderPages'
import AlbumEditDetail from './AlbumEditDetail'
import AlbumEditPages from './AlbumEditPages'
import AlbumShare from './AlbumShare'
import PageMaster from './PageMaster'
export default {
  props: ['album', 'updateAlbum', 'updatePageOrder', 'deletePage', 'updatePage', 'deleteAlbum', 'route', 'createPage'],
  data: function () {
    return {
      ...this.getShowHideData(this.route),
      showDropzone: this.album.pages.length === 0,
      awss3: {
        signingURL: '/api/s3/sign',
        sendFileToServer: false,
      },
      dropzoneOptions: {
        thumbnailWidth: 150,
        maxFilesize: 5,
        uploadMultiple: true,
        // For paramName, see https://github.com/rowanwins/vue-dropzone/issues/533#issuecomment-720162342
        paramName: () => 'file',
        successmultiple: (fileList, response) => {
          const location = response.match(/<Location>(.*)<\/Location>/)[1]
          this.createPage(location)
        },
      },
    }
  },
  methods: {
    s3UploadError(errorMessage) {
      this.$snotify.error('There was an error uploading the image: ' + errorMessage)
    },
    viewAlbum,
    shareAlbum,
    albumEdit,
    bulkEditPages,
    getShowHideData(route) {
      return {
        isEditing: route.name === 'albumEdit',
        isEditingPages: route.name === 'albumPagesEdit',
        isSharing: route.name === 'albumShare',
        isPage: route.name === 'pageEdit',
      }
    },
  },
  components: {
    AlbumEditDetail,
    AlbumEditPages,
    AlbumShare,
    OrderPages,
    vueDropzone: vue2Dropzone,
    PageMaster,
  },
  watch: {
    route(newRoute) {
      Object.assign(this.$data, this.getShowHideData(newRoute))
    },
  },
}
</script>

<style lang="stylus" scoped>
.notes, .credits
  font-size smaller

.pill
  background #f2cf63
</style>
